export const SELECTOR_BALANCE = (state) => state.eWallet.balance;
export const SELECTOR_BALANCE2 = (state) => state.eWallet.balance2;
export const SELECTOR_BALANCE3 = (state) => state.eWallet.balance3;

export const SELECTOR_E_WALLET = (state) =>
  Object.values(state.eWallet.eWallet);

export const SELECTOR_E_WALLET_PAGINATION = (state) =>
  Object.values(state.eWallet.eWalletPagination);

export const SELECTOR_CUSTOM_PAYMENTS = (state) =>
  Object.values(state.eWallet.customPayments);

export const SELECTOR_CUSTOM_PAYMENTS_PAGINATION = (state) =>
  Object.values(state.eWallet.customPaymentsPagination);
